import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withSnackbar } from "notistack";
import { isMobile, isMobileOnly, isTablet } from "react-device-detect";
import { startLoadingAnimate, stopLoadingAnimate, } from "services/ducks/loading";
import { Row, Col } from "react-bootstrap";
import * as FontAwesome from "@fortawesome/react-fontawesome";
import { TextField } from "@material-ui/core";
import { faSave } from "@fortawesome/free-regular-svg-icons";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons"
import { ContainerTitle, FullSizedButton } from "../styles";
import { DeclaracaoSubtitle } from "./styles";
import NumberFormat from "react-number-format";
import api from "services/structure/api";
import { numberFormatter } from "services/structure/numberUtils";

class MeuPlanoAlterarBeneficio extends Component {

  state = {
    parametros: {}
  }



  downloadParametrosContribuicao() {
    return api.get("/beneficio/dados-beneficio-cd")
      .then(response => {
        const parametros = response.data;
        this.setState({ parametros: parametros });
        this.props.stopLoadingAnimate();
      })
      .catch((e) => {
        const mensagem = "Não foi possível conectar-se ao servidor. Recarregue a página! ";
        this.props.enqueueSnackbar(mensagem, { variant: 'error' });
        console.log(e);
      });
  }


  componentDidMount() {
    this.props.startLoadingAnimate();
    const promises = [];
    promises.push(this.downloadParametrosContribuicao());


    Promise.all(promises)
      .finally(() => this.props.stopLoadingAnimate());

    window.scrollTo(0, 0);
  }

  navigateTo(route) {
    this.props.history.push(route);
  }


  //benefício
  changeValorAtributoNumerico = (nomeAtributo, e) => {
    let val = numberFormatter.unformat(isNaN(e.floatValue) ? 0 : e.floatValue);
    if (!Number.isNaN(val)) {
      const parametros = this.state.parametros;
      parametros[nomeAtributo] = val
      this.setState({ parametros: parametros });
    }
  }


  salvarParametrosBeneficio = () => {
    const parametros = this.state.parametros;
    const payload = {};
    let valid = true;

    payload.valorBeneficioNovo = parametros.valorBeneficioNovo;

    if (!valid) {
      return;
    }

    this.props.startLoadingAnimate();
    api.post("/beneficio/salvar-novo-valor-beneficio-cd", parametros)
      .then(response => {
        this.props.stopLoadingAnimate();
        const mensagem = "Benefício alterado com sucesso! ";
        this.props.enqueueSnackbar(mensagem, { variant: 'success' });
        this.downloadParametrosContribuicao().finally(() => this.props.stopLoadingAnimate());
        //parametros =  response.data;
      })
      .catch((e) => {
        let mensagem = "Não foi possível conectar-se ao servidor. Tente novamente! ";
        if(e?.response?.data?.mensagem) {
          mensagem = e.response.data.mensagem;
        }
        this.props.enqueueSnackbar(mensagem, { variant: 'error' });
        console.log(e);
      })
      .finally(() => {
        this.props.stopLoadingAnimate()
      });
  }


  renderResumoParametrosBeneficio = () => {
    return (
      <DeclaracaoSubtitle>
        <span>
        Saldo Total do Participante: <NumberFormat
            value={this.state.parametros.saldoTotalParticipante}
            displayType={"text"}
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            prefix={"R$ "}
          />
          <br />
        </span>
        <span>
        Qtd. Benefícios Pago: <NumberFormat
            value={this.state.parametros.qtdBeneficiosPagos}
            displayType={"text"}
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
          />
          <br />
        </span>
        <span>
        Valor Benefício Atual: <NumberFormat
            value={this.state.parametros.valorBeneficioAtual}
            displayType={"text"}
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            prefix={"R$ "}
          />
          <br />
      </span>
        <span>
        Qtd. Benefícios à Pagar:: <NumberFormat
            value={this.state.parametros.qtdBeneficioPagar}
            displayType={"text"}
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
          />
          <br />
        </span>
      </DeclaracaoSubtitle>
    )
  }

  renderEdicaoContribuicaoVoluntariaValorAbsoluto = () => {
    return (
      <div>
          {
              <div className="input-text-percent">
                  <NumberFormat
                      value={this.state.info?.valorBeneficioNovo}
                      thousandSeparator="."
                      decimalSeparator=","
                      customInput={TextField}
                      onValueChange={e => this.changeValorAtributoNumerico('valorBeneficioNovo', e)}
                      variant="outlined"
                      decimalScale={2}
                      fixedDecimalScale={2}
                      label="Novo Valor do Benefício"
                      name="valorBeneficioNovo"
                      prefix={"R$ "}
                      fullWidth
                      className="MuiFormControl-marginNormal"
                  />
              </div>
          }
          
      </div>
    )
  }



  render() {
    return (
      <div className="meu-plano-alterar-beneficio">
        {isTablet && <ContainerTitle>MEU PLANO | <span className="meu-plano-alterar-beneficio-subtitle-container">ALTERAR BENENFÍCIO</span></ContainerTitle>}
        <Row className="meu-plano-alterar-beneficio-title-container">
          <Col sm={isTablet ? 6 : 8}>
            {!isMobile && <ContainerTitle>MEU PLANO | <span className="meu-plano-alterar-beneficio-subtitle-container">ALTERAR BENENFÍCIO</span></ContainerTitle>}
            {isMobileOnly && <ContainerTitle>MEU PLANO <br /> <span className="meu-plano-alterar-beneficio-subtitle-container">ALTERAR BENENFÍCIO</span></ContainerTitle>}
            {isMobileOnly && <img src={process.env.PUBLIC_URL + '/alterar-contribuicao-subtitle.png'} className="alterar-contribuicao-subtitle" alt="" />}
            {
              !this.state.parametros.contribuicaoValorAbsoluto &&
              this.renderResumoParametrosBeneficio()
            }
          </Col>
          <Col sm={isTablet ? 6 : 4}>
            {!isMobileOnly && <img src={process.env.PUBLIC_URL + '/alterar-contribuicao-subtitle.png'} className="alterar-contribuicao-subtitle" alt="" />}
          </Col>
        </Row>
        <div className={this.state.parametros.contribuicaoValorAbsoluto ? "edicao-valor-absoluto" : "edicao-valor-percentual"}>
          <div className={!isMobile ? "contribuicao-container-desktop" : ""}>

            <div className="contribuicao-voluntaria">
              <div className="contribuicao-voluntaria-session-edit">

                {
                  this.renderEdicaoContribuicaoVoluntariaValorAbsoluto()
                }
              </div>
            </div>
          </div>
        </div>
        <div className="contribuicao-divisor"></div>

        <Row>
          {!isTablet && <Col sm={6}></Col>}
          <Col sm={isTablet ? 6 : 3}>
            <FullSizedButton
              type="submit"
              className="alterar-contribuicao-salvar-button"
              variant="contained"
              onClick={this.salvarParametrosBeneficio}
              disabled={false}>
              <FontAwesome.FontAwesomeIcon icon={faSave} className="alterar-contribuicao-salvar-icon" />
              <span className="alterar-contribuicao-salvar-label">SALVAR ALTERAÇÕES</span>
            </FullSizedButton>
          </Col>
          <Col sm={isTablet ? 6 : 3}>
            <FullSizedButton
              type="submit"
              className="alterar-contribuicao-voltar-button"
              variant="contained"
              onClick={() => this.navigateTo('/app/meu-plano')}>
              <FontAwesome.FontAwesomeIcon icon={faArrowLeft} className="alterar-contribuicao-voltar-icon" />
              <span className="alterar-contribuicao-voltar-label">VOLTAR AO MENU ANTERIOR</span>
            </FullSizedButton>
          </Col>
        </Row>

      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  authData: store.authState,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
    startLoadingAnimate,
    stopLoadingAnimate
  }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withSnackbar(MeuPlanoAlterarBeneficio)));
